<template>
  <div class="pushPreview">
    <div class="chatInner">
      <div class="templates-wrap">
        <push-template-media-text
        >
        </push-template-media-text>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import pushTemplateMediaText from '../../push/components/pushTemplateMediaText'
import pushTemplateImage from '../../push/components/pushTemplateImage'
import pushTemplateText from '../../push/components/pushTemplateText'

export default {
  metaInfo: {
    title: 'プレビュー'
  },
  props: {
  },
  data () {
    return {
      dialog: false,
      isV2Channel: false,
      type: '',
      object: [],
      brandName: ''
    }
  },
  computed: {
    ...mapGetters([
      'marketingTemplateContent',
      'marketingPreiviewLayout'
    ])
  },
  components: {
    pushTemplateText, pushTemplateMediaText, pushTemplateImage
  },
  created () {
    this.brandInfo()
    if (this.$route.query.marketingId) {
      this.isV2Channel = this.$route.query.isV2Channel
      this.marketingId = this.$route.query.marketingId
    }
  },
  mounted () {
    // this.changeTemplateContent()
  },
  methods: {
    ...mapMutations([
      'selectTemplate',
      'changeTemplateView'
    ]),
    changeTemplate (type) {
      this.type = type
    },
    changeTemplateContent () {
      try {
        this.$http.get('/api/marketing/fetchMarketingContent', {
          params: {
            marketingId: this.marketingId
          }
        })
          .then(result => {
            const response = result.data
            if (response.code === 0) {
              let selectdata = {
                marketingId: response.data.marketingFlowViews[0].data.marketingTemplateId,
                marketingName: response.data.marketingFlowViews[0].data.marketingTemplateTitle
              }
              this.selectTemplate(selectdata)
              this.changeTemplateView(response.data.marketingFlowViews[0].data)
            } else {
              throw response.message
            }
          })
          .catch(errorMsg => {
            this.$alertMsg(errorMsg)
          })
      } catch (e) {
        console.log(e)
      }
    },
    brandInfo () {
      this.$http.get('/api/agent/fetchBrands').then(result => {
        let brands = result.data.data
        if (result.data.code === 0) {
          this.brandName = brands[0].name
        } else {
          this.$alertMsg(result.data.message)
        }
      })
    }
  }
}
</script>

<style lang="scss">
  // @import url("components/fragments/css/marketingFlexEditor.css");
  .pushPreview {
    width: 440px;
    padding-bottom: 30px;
    margin: 20px auto 0;
    .closeBtn {position: absolute; margin-top: 10px; right: 40px;background: #ff8c8c;border-radius: 100%;padding: 3px;transition: all ease .3s;cursor: pointer; z-index: 1;}
    .closeBtn:hover {opacity: .7;}
    .closeBtn i {position: relative;width: 16px;height: 16px;display: block;}
    .closeBtn i::before, .closeBtn i::after {position: absolute;content: "";width: 11px;height: 2px;background: #fff;border-radius: 10px;top: 0;left: 0;right: 0;bottom: 0;margin: auto;}
    .closeBtn i::before {transform: rotate(45deg);}
    .closeBtn i::after {transform: rotate(-45deg);}
    .head {
      padding-right: 5px;
      background: #ff8c8c;
      display: flex;
      justify-content: space-between;
      border-radius: 10px 10px 0px 0px;
      p {
        position: relative;
        margin: 0;
        color: #fff;
        font-size: 20px;
        font-weight: bold;
        :before {
          position: absolute;
          content: "";
          background: url();
          width: 20px;
          height: 21px;
          top: 0;
          bottom: 0;
          left: 0;
          margin: auto;
        }
      }
    }
    .chatInner {
      .template-edit-area {
        &:hover {
          transform: none;
          box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.14);
        }
      }
      .line_temp {
        &__ttl {
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 6px;
        }
      }
      .add-btn-basic {
        border: none;
        background: none;
        margin-top: 20px;
        &:hover {
          border: none;
        }
        .v-list__tile__title {
          text-align: center;
        }
        .v-list__tile__action {
          display: none;
        }
      }
    }
    .pushBottom{
      float: right;
      padding-bottom: 10px;
      .chatbot-img {
        border-radius: 50%;
      }
    }
    .ritBtn {
      padding: 0 !important;
      i {
        padding: 7px;
        display: inline-block;
        font-size:24px;
        font-weight: 700;
        color: #fff;
      }
    }
  }
  .chatTop {
    color: #fff;
    .chatTopTitle {
      position: relative;
      padding: 0px 0 0px 40px;
      max-height: 40px;
      overflow: hidden;
      background: url('https://public-common-sdk-outaigate.s3.ap-northeast-3.amazonaws.com/image/common/logo_white.svg') no-repeat;
      background-size: 30px 40px;
      -webkit-transition: max-height .3s, padding .3s;
      transition: max-height .3s, padding .3s;
      span {
        position: relative;
        display:inline-block;
        width: 100%;
        font-size: 16px;
        line-height: 40px;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: top;
      }
      &::after {
        font-family: 'twc';
        content: '\e912';
        position: absolute;
        bottom: -2px;
        left: 50%;
        width:100%;
        font-size: 18px;
        -webkit-transition: all .3s;
        transition: all .3s;
        -webkit-transform: translateY(20px);
      }
      &.show {
        max-height: 200px;
        dt {
          overflow: initial;
          text-overflow: initial;
          white-space: initial;
        }
        dd {
          overflow: initial;
          text-overflow: initial;
          white-space: initial;
        }
        &::after {
          -webkit-transform: translateY(0);
        }
      }
    }
    .title {
      padding-bottom: 4px;
      font-size: 16px;
      min-height: 70px;
      font-weight: bold;
      display: flex;
      align-items: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/menus/marketing/marketingPushPreview.vue